import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { SystemLogin } from '@/models/system/SystemLogin';
import { QuartzInfo } from '@/models/system/QuartzInfo';
import { FormsFiltersModel } from '@/models/system/FormsFilters';
import { ProcessCompareRequest } from '@/models/system/process-compare-request';

export interface SystemState {
  credentials: SystemLogin;
  systemErrors: string[];
  systemQuartzErrors: string[];
  systemJobsErrors: string[];
  systemStatisticsErrors: string[];
  loginPending: boolean;
  systemCacheList: string[];
  systemJobsLogsList: string[];
  systemJobLog: string[];
  token: string;
  refreshMessage: string;
  quartzInfo: QuartzInfo;
  formsFilters: FormsFiltersModel;
  runForm101PdfGeneratorJobErrors: string[];
  runForm101PdfFilesExportJobErrors: string[];
  runForm101PdfComsignJobErrors: string[];
  testMailsErrors: string[];
  processCompareRequest: ProcessCompareRequest;
  processCompareRequestsErrors: string[];
  processCompareRequestsLoading: boolean;
  openTermsAndPrivacyModal: boolean;
}

export const initialState = ((): SystemState => {
  return {
    credentials: { userName: null, otpCode: null },
    systemErrors: [],
    systemQuartzErrors: [],
    systemJobsErrors: [],
    systemStatisticsErrors: [],
    loginPending: false,
    systemCacheList: [],
    systemJobsLogsList: [],
    systemJobLog: [],
    token: '',
    refreshMessage: '',
    quartzInfo: {
      status: 0,
      summary: '',
      numberOfJobsExecuted: 0,
      runningSince: '',
      triggers: [],
      runningJobs: [],
    },
    formsFilters: {
      officeNum: -1,
      taxYear: -1,
      firstResult: 0,
      maxResults: 10,
      asJob: false,
      detailedLog: false,
    },
    runForm101PdfGeneratorJobErrors: [],
    runForm101PdfFilesExportJobErrors: [],
    runForm101PdfComsignJobErrors: [],
    testMailsErrors: [],
    processCompareRequest: {} as ProcessCompareRequest,
    processCompareRequestsErrors: [],
    processCompareRequestsLoading: false,
    openTermsAndPrivacyModal: false,
  };
});

export const system: Module<SystemState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
